module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": _vm.titulo
    }
  }), _vm._v(" "), _c('div', {}, [_c('section', {
    staticClass: "content-header "
  }, [_c('h1', [_vm._v("Proposta\n          "), _vm._v(" "), (_vm.bloqueiaBotoes === false && _vm.travarEdicao === false) ? _c('span', [(_vm.mostrarRef('botao_concluir') && this.$router.currentRoute.name === 'proposta-edita') ? _c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirmaConclusao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('botao_salvar') && this.$router.currentRoute.name === 'proposta-edita') ? _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirmaSalvamento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), ((_vm.proposta.ds_fase === 'ANALISE' || _vm.proposta.ds_fase === 'CADASTRO') &&
    this.$router.currentRoute.name === 'proposta-edita' &&
    _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-moema', {
    attrs: {
      "color": "error",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelarProposta($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar Proposta\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('botao_voltar') && this.$router.currentRoute.name === 'proposta-visualiza' && this.$route.params.aprovAnt) ? _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'validacao-inicial',
          params: {
            id: _vm.$route.params.aprovAnt
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('botao_voltar') && this.$router.currentRoute.name === 'proposta-visualiza' && this.$route.params.aprovAnt2) ? _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'validacao-entidades',
          params: {
            id: _vm.$route.params.aprovAnt2
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('botao_voltar') && this.$router.currentRoute.name === 'proposta-edita' || (this.$router.currentRoute.name === 'proposta-visualiza' && this.$route.params.aprovAnt === undefined && this.$route.params.aprovAnt2 === undefined)) ? _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.proposta.ds_fase === 'DEFERIMENTO' || _vm.proposta.ds_fase === 'APROVACAO_PROJETO') ? _c('span', [_c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none",
      "height": "34px",
      "margin-top": "3px",
      "padding-top": "8px",
      "margin-left": "30px"
    },
    attrs: {
      "to": {
        name: 'relatorio-analise',
        params: {
          id: this.$route.params.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Relatório de Análise")]), _vm._v(" "), (_vm.proposta.fep) ? _c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none",
      "height": "34px",
      "margin-top": "3px",
      "padding-top": "8px"
    },
    attrs: {
      "to": {
        name: 'relatorio-fep',
        params: {
          id: this.$route.params.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  FEP nº " + _vm._s(_vm.proposta.fep.ano) + " / " + _vm._s(_vm.proposta.fep.numero))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none",
      "height": "34px",
      "margin-top": "3px",
      "padding-top": "8px"
    },
    attrs: {
      "to": {
        name: 'relatorio-rating',
        params: {
          id: this.$route.params.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("  Rating da Entidade")])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.travarEdicao) ? _c('span', [_vm._v(" A edição da proposta neste edital está desabilitada. ")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.progressBar.stepTotal) && _vm.finalizou === false) ? _c('b-progress', {
    staticClass: "w-50 mb-2",
    attrs: {
      "max": _vm.progressBar.stepTotal
    }
  }, [_c('b-progress-bar', {
    attrs: {
      "value": _vm.progressBar.stepAtual
    }
  }, [_vm._v("\n            " + _vm._s(_vm.progressBar.tarefaAtual) + " :   "), _c('strong', [_vm._v(_vm._s(_vm.progressBar.stepAtual) + " / " + _vm._s(_vm.progressBar.stepTotal))])])], 1) : _vm._e(), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Proposta',
        href: '#'
      }, {
        text: 'Edita',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('br'), _vm._v(" "), (_vm.proposta.ds_fase === 'REVISAO' && !_vm._.isUndefined(_vm.historico_atualizado) && _vm.historico_atualizado.length > 1 && _vm.historico_atualizado[1].observacao !== null) ? _c('div', {
    staticClass: "alert alert-dismissible alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.historico_atualizado[1].observacao)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    ref: "topo"
  }, [(((!_vm._.isEmpty(_vm.restricoesAtivasProjetosDaEntidade) || !_vm._.isEmpty(_vm.restricoesAtivasEntidade)) && _vm.usuarioLogado.userType === 'FUNDACAO')) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((this.restricoesAtivasEntidade), function(restricaoEntidade) {
    return _c('p', [_vm._v("\n                  " + _vm._s(restricaoEntidade.codoco) + " - " + _vm._s(restricaoEntidade.desroc) + "\n                ")])
  }), _vm._v(" "), _vm._l((this.restricoesAtivasProjetosDaEntidade), function(restricaoProjeto) {
    return _c('p', [_vm._v("\n                  " + _vm._s(restricaoProjeto.codoco) + " - " + _vm._s(restricaoProjeto.desroc) + "\n                ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.proposta, 'rating.consultas.PEP', 0) > 0 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("Indicou no Rating da Entidade que há " + _vm._s(_vm.proposta.rating.consultas.PEP) + " " + _vm._s(_vm.proposta.rating.consultas.PEP > 1 ? 'Pessoas Expostas' : 'Pessoa Exposta') + " Politicamente (PEP), então deve encaminhar o deferimento para o C.E.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.proposta.ds_fase !== 'REVISAO' && _vm.proposta.ds_fase !== 'CADASTRO') ? _c('div', {
    staticClass: "text-left box-header"
  }, [(_vm.esconder === false) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconder = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar a proposta "), _c('b', [(_vm.proposta.ds_codigo_projeto_erp) ? _c('span', [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - ")]) : _vm._e(), _vm._v(_vm._s(_vm.proposta.ds_nome))])]) : _vm._e(), _vm._v(" "), (_vm.esconder === true) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconder = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocultar a proposta "), _c('b', [(_vm.proposta.ds_codigo_projeto_erp) ? _c('span', [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - ")]) : _vm._e(), _vm._v(_vm._s(_vm.proposta.ds_nome))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.esconder === true || _vm.proposta.ds_fase === 'REVISAO' || _vm.proposta.ds_fase === 'REVISAO'),
      expression: "esconder === true || proposta.ds_fase === 'REVISAO' || proposta.ds_fase === 'REVISAO'"
    }],
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || (_vm._.includes(['DEFERIMENTO', 'FORMALIZACAO', 'APROVACAO_PROJETO'], _vm.proposta.ds_fase)) || _vm.proposta.ds_fase === 'FORMALIZACAO'
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field required",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [(_vm.mostrarRef('projeto_numero')) ? _c('div', [_c('div', [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nº do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposta.ds_codigo_projeto_erp"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_codigo_projeto_erp),
      expression: "proposta.ds_codigo_projeto_erp"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "idProjectErp",
      "type": "number",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.proposta.ds_codigo_projeto_erp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_codigo_projeto_erp", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_nome')) ? _c('div', [_c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_nome),
      expression: "proposta.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:150'),
      expression: "'required|max:150'"
    }],
    staticClass: "form-control col",
    attrs: {
      "name": "nome",
      "data-vv-as": "Nome da Proposta",
      "type": "text",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.proposta.ds_nome)
    },
    on: {
      "keypress": _vm.retiraAspas,
      "paste": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.mostrarRef('coordenador') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), (_vm.mostrarRef('coordenador_nome')) ? _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('nome do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorName"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_nome_coordenador),
      expression: "proposta.ds_nome_coordenador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome do coordenador",
      "type": "text",
      "data-vv-as": "Nome do Coordenador",
      "maxlength": "100",
      "data-cy": "nome_do_coordenador"
    },
    domProps: {
      "value": (_vm.proposta.ds_nome_coordenador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_nome_coordenador", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_cpf')) ? _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('cpf do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorCpf"
    }
  }, [(this.$router.currentRoute.name === 'proposta-visualiza') ? _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "cpf do coordenador",
      "type": "text",
      "data-vv-as": "CPF do Coordenador",
      "mask": '###.###.###-##',
      "data-cy": "cpf_do_coordenador"
    },
    model: {
      value: (_vm.proposta.ds_cpf_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_cpf_coordenador", $$v)
      },
      expression: "proposta.ds_cpf_coordenador"
    }
  }) : _vm._e(), _vm._v(" "), (this.$router.currentRoute.name !== 'proposta-visualiza') ? _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf do coordenador",
      "type": "text",
      "mask": '###.###.###-##',
      "data-cy": "cpf_do_coordenador"
    },
    model: {
      value: (_vm.proposta.ds_cpf_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_cpf_coordenador", $$v)
      },
      expression: "proposta.ds_cpf_coordenador"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_email')) ? _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('ds_email_coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorEmail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_email_coordenador),
      expression: "proposta.ds_email_coordenador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|max:255'),
      expression: "'required|email|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_email_coordenador",
      "type": "email",
      "data-vv-as": "E-mail do Coordenador",
      "maxlength": "255",
      "data-cy": "ds_email_coordenador"
    },
    domProps: {
      "value": (_vm.proposta.ds_email_coordenador)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_email_coordenador", $event.target.value)
      }, function($event) {
        _vm.proposta.ds_email_coordenador = $event.target.value.toLowerCase()
      }]
    }
  })]), _vm._v(" "), (_vm.errors.first('ds_email_coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('ds_email_coordenador')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_telefone')) ? _c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "tel",
      "data-vv-as": "Telefone do Coordenador",
      "mask": ['(##) ####-####', '(##) #####-####'],
      "data-cy": "ds_telefone_coordenador"
    },
    model: {
      value: (_vm.proposta.ds_telefone_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_telefone_coordenador", $$v)
      },
      expression: "proposta.ds_telefone_coordenador"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('coordenador_celular')) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Celular",
      "type": "tel",
      "data-vv-as": "Celular do Coordenador",
      "mask": ['(##) ####-####', '(##) #####-####'],
      "data-cy": "ds_celular_coordenador"
    },
    model: {
      value: (_vm.proposta.ds_celular_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_celular_coordenador", $$v)
      },
      expression: "proposta.ds_celular_coordenador"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('legend', [_vm._v("Período de execução do projeto")]), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', [(_vm.mostrarRef('projeto_data_inicial')) ? _c('div', {
    staticClass: " col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Data Inicial')
    },
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data prevista para início")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    attrs: {
      "name": "proposal.initialDate"
    }
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "Data Inicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": false,
      "placeholder": "__ /__ /____",
      "data-vv-as": "Data Inicial",
      "format": "dd/MM/yyyy",
      "data-cy": "dt_data_inicial"
    },
    model: {
      value: (_vm.proposta.dt_data_inicial),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "dt_data_inicial", $$v)
      },
      expression: "proposta.dt_data_inicial"
    }
  })], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('periodo')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.periods"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.nr_periodos),
      expression: "proposta.nr_periodos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1'),
      expression: "'required|min_value:1'"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Número de Meses do Projeto",
      "lang": "pt-br",
      "name": "periodo",
      "type": "number",
      "min": "1",
      "data-cy": "nr_periodos"
    },
    domProps: {
      "value": (_vm.proposta.nr_periodos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "nr_periodos", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "form-group required-field col-md-12 required"
  }, [_c('div', {
    staticClass: " col-md-12 required",
    class: {
      'has-error': _vm.errors.first('periodoVigencia')
    },
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Período de vigência ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.periodo_vigencia),
      expression: "proposta.periodo_vigencia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:' + _vm.proposta.nr_periodos),
      expression: "'required|min_value:' + proposta.nr_periodos"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Período Vigência",
      "lang": "pt-br",
      "name": "periodoVigencia",
      "type": "number"
    },
    domProps: {
      "value": (_vm.proposta.periodo_vigencia)
    },
    on: {
      "change": function($event) {
        return _vm.datas()
      },
      "keyup": function($event) {
        return _vm.datas()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "periodo_vigencia", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.errors.first('periodoVigencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodoVigencia')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "form-group required-field col-md-12 required"
  }, [_c('div', {
    staticClass: " col-md-12 required",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de Vigência do Projeto ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('dd', {}, [_vm._v(_vm._s(_vm.dataVigencia))])])]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_periodos') && _vm.mostrarRef('projeto_data_inicial')) ? _c('dl', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {}, [_vm._v(_vm._s(_vm.dataFinal))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "text-left box-header"
  }, [(_vm.esconderEntidade === false) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderEntidade = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar dados da Entidade - "), _c('span', {
    staticStyle: {
      "color": "steelblue",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]) : _vm._e(), _vm._v(" "), (_vm.esconderEntidade === true) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderEntidade = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocultar dados da Entidade - "), _c('span', {
    staticStyle: {
      "color": "steelblue",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]) : _vm._e()]), _vm._v(" "), (_vm.esconderEntidade === true) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('legend', [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
    staticClass: "proposal-definition-list"
  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {}, [_c('router-link', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "title": '<h5>Ir para o Cadastro da entidade</h5>',
      "to": {
        name: 'cadastro-entidade-visualiza',
        params: {
          id: _vm.proposta.entidade.id
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.proposta.entidade.ds_nome) + "  "), _c('i', {
    staticClass: "fa fa-external-link"
  })])], 1), _vm._v(" "), _c('dt', [_vm._v("CNPJ")]), _vm._v(" "), _c('dd', [_vm._v("\n                                " + _vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)) + "\n                              ")]), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {}, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), (_vm.proposta.entidade.endereco[0]) ? _c('dd', {}, [_vm._v(_vm._s(_vm.proposta.entidade.endereco[0].ds_rua) + ", " + _vm._s(_vm.proposta.entidade.endereco[0].ds_numero) + " -\n                                " + _vm._s(_vm.proposta.entidade.endereco[0].ds_bairro) + ", " + _vm._s(_vm.proposta.entidade.endereco[0].ds_cidade) + " - " + _vm._s(_vm.proposta.entidade.endereco[0].ds_estado) + "\n                              ")]) : _vm._e(), _vm._v(" "), _c('dt', [_vm._v("Telefone")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "phone"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.telefone) + "\n                              ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.mostrarRef('informacoes_introdutorias_introducao') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
    staticClass: "form-group required-field required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('introducao')
    }
  }, [_c('label', {
    staticClass: "control-label ",
    attrs: {
      "for": "introduction"
    }
  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {}, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.ehEdital ? '' : 'Nenhum texto informativo...',
      "min-height": 200,
      "autosize": true,
      "name": "introducao",
      "data-vv-as": "Informações Introdutórias do Projeto",
      "rows": "4",
      "data-cy": "ds_introducao"
    },
    on: {
      "input": _vm.resizable
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.onBlurTextarea($event)
      }
    },
    model: {
      value: (_vm.proposta.ds_introducao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_introducao", $$v)
      },
      expression: "proposta.ds_introducao"
    }
  }), _vm._v(" "), (_vm.errors.first('introducao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('introducao')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_apresentacao')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('apresentacao')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "presentation"
    }
  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.presentation"
    }
  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "apresentacao",
      "rows": "4",
      "min-height": 200,
      "autosize": true,
      "data-cy": "ds_apresentacao",
      "data-vv-as": "Apresentação do Projeto"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_apresentacao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_apresentacao", $$v)
      },
      expression: "proposta.ds_apresentacao"
    }
  }) : _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "apresentacao",
      "rows": "4",
      "min-height": 200,
      "autosize": true,
      "data-cy": "ds_apresentacao",
      "data-vv-as": "Apresentação do Projeto",
      "placeholder": "Descreva aqui histórico, capacidade técnica e experiências da sua organização. Utilize os tópicos abaixo para orientar seu texto:\n- Por que sua organização foi criada. Qual o seu propósito?\n- Quais são as principais atividades desenvolvidas pela sua instituição?\n- A sua organização possui experiência acumulada no mesmo tema da atual proposta? Cite os projetos mais importantes, descrevendo os resultados alcançados, perfil e número de participantes atendidos.\n- Qual a infraestrutura disponível para a sua organização? Existem planos para expansão?\n- Quais são seus principais parceiros e apoiadores?\n- Como sua organização garante a continuidade de suas ações?\n- A sua entidade possui uma estratégia de captação de recursos?\n- A sua instituição possui associados ou cooperados? Cite quantidade e perfil.\n- Como funciona a interação da organização com a comunidade?\n- A comunidade participa dos processos de tomada de decisão da sua organização?"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_apresentacao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_apresentacao", $$v)
      },
      expression: "proposta.ds_apresentacao"
    }
  }), _vm._v(" "), (_vm.errors.first('apresentacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('apresentacao')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_territorio')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('territorio')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "territory"
    }
  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.territory"
    }
  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Território de Desenvolvimento do Projeto",
      "name": "territorio",
      "rows": "4",
      "data-cy": "ds_territorio"
    },
    on: {
      "input": _vm.resizable
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.onBlurTextarea($event)
      }
    },
    model: {
      value: (_vm.proposta.ds_territorio),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_territorio", $$v)
      },
      expression: "proposta.ds_territorio"
    }
  }) : _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Território de Desenvolvimento do Projeto",
      "name": "territorio",
      "rows": "4",
      "data-cy": "ds_territorio",
      "placeholder": "Descreva aqui o contexto local, considerando aspectos sociais, econômicos e ambientais do município e da comunidade a ser assistida. Utilize os tópicos abaixo para orientar seu texto:\n- Quais as características socioeconômicas, ambientais e culturais da região?\n- Além dos beneficiários e da sua organização, quem são os demais interessados pelo projeto?\n- Quais são os equipamentos sociais* e serviços públicos que estão disponíveis para a comunidade local?\n- Como é a relação da instituição e da comunidade com o poder público local?\n- De que maneira a realidade local se relaciona ao projeto proposto?\n- De que maneira a realidade local pode ser uma barreira para o desenvolvimento do projeto?\n\n*São equipamento sociais: postos de saúde, creches, pré-escolas, centros comunitários, etc."
    },
    on: {
      "input": _vm.resizable
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.onBlurTextarea($event)
      }
    },
    model: {
      value: (_vm.proposta.ds_territorio),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_territorio", $$v)
      },
      expression: "proposta.ds_territorio"
    }
  }), _vm._v(" "), (_vm.errors.first('territorio')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('territorio')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_justificativa')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12  required",
    class: {
      'has-error': _vm.errors.first('propostaJustificativa')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justification"
    }
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.justification"
    }
  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Justificativa do Projeto",
      "name": "propostaJustificativa",
      "rows": "4",
      "data-cy": "ds_justificativa"
    },
    on: {
      "input": _vm.resizable
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.onBlurTextarea($event)
      }
    },
    model: {
      value: (_vm.proposta.ds_justificativa),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_justificativa", $$v)
      },
      expression: "proposta.ds_justificativa"
    }
  }) : _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Justificativa do Projeto",
      "name": "propostaJustificativa",
      "rows": "4",
      "data-cy": "ds_justificativa"
    },
    on: {
      "input": _vm.resizable
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.onBlurTextarea($event)
      }
    },
    model: {
      value: (_vm.proposta.ds_justificativa),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_justificativa", $$v)
      },
      expression: "proposta.ds_justificativa"
    }
  }, [_vm._v("\n                                              placeholder=\"Descreva aqui o problema que a sua organização quer solucionar. Utilize os tópicos abaixo para orientar seu texto:\n- Qual é a situação-problema a ser solucionado?\n- Quais as suas origens?\n- Quais os fatores sociais, políticos, ambientais e culturais que o agravam?\n- Quais são as consequências desse problema para a região e para o público alvo da proposta?\">\n                                    ")]), _vm._v(" "), (_vm.errors.first('propostaJustificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('propostaJustificativa')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_objetivo_geral')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12  required",
    class: {
      'has-error': _vm.errors.first('objetivo Geral')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "generalObjective"
    }
  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.generalObjective"
    }
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Objetivo Geral do Projeto",
      "name": "objetivo Geral",
      "rows": "4",
      "data-cy": "ds_objetivo_geral",
      "placeholder": _vm.ehEdital ? '' : 'Defina de forma sucinta o que se pretende alcançar com o projeto. O objetivo geral deve refletir a transformação desejada pela sua organização, levando em consideração o problema apresentado e a solução proposta. Ele deve ser passível de ser alcançado por meio dos objetivos específicos e as atividades propostas. O objetivo deve ser iniciado com um verbo no infinitivo, exemplo: elevar, aprimorar, fortalecer, transformar, etc.'
    },
    on: {
      "input": _vm.resizable
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.onBlurTextarea($event)
      }
    },
    model: {
      value: (_vm.proposta.ds_objetivo_geral),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_objetivo_geral", $$v)
      },
      expression: "proposta.ds_objetivo_geral"
    }
  }), _vm._v(" "), (_vm.errors.first('objetivo Geral')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo Geral')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_resultados')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Resultados esperados')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "results"
    }
  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.results"
    }
  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Resultados Esperados do Projeto",
      "name": "Resultados esperados",
      "rows": "4",
      "data-cy": "ds_resultados"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_resultados),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_resultados", $$v)
      },
      expression: "proposta.ds_resultados"
    }
  }) : _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Resultados Esperados do Projeto",
      "name": "Resultados esperados",
      "rows": "4",
      "data-cy": "ds_resultados",
      "placeholder": "Descreva quais os efeitos e reflexos esperados sobre o cotidiano da comunidade por meio da implantação do projeto proposto.\nOs resultados esperados devem ser coerentes com os objetivos propostos."
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_resultados),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_resultados", $$v)
      },
      expression: "proposta.ds_resultados"
    }
  }), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_operacionalizacao') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Operacionalização')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.operation"
    }
  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Operacionalização do Projeto",
      "name": "Operacionalização",
      "rows": "4",
      "data-cy": "ds_operacao"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_operacao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_operacao", $$v)
      },
      expression: "proposta.ds_operacao"
    }
  }) : _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Operacionalização do Projeto",
      "name": "Operacionalização",
      "rows": "4",
      "data-cy": "ds_operacao",
      "placeholder": "Descreva aqui o que a sua organização apresenta como método para a execução das atividades. Utilize os tópicos abaixo para orientar seu texto:\n- Quais são as etapas, processos e rotinas previstas para o projeto?\n- O método já foi utilizado em outras situações?\n- Será utilizada alguma tecnologia social?\n- O método já foi sistematizado? Há previsão de sistematização (caso não haja processo sistematizado)?\n- Como será realizado o processo de seleção dos participantes?\n- Qual a estratégia para manutenção das ações do projeto após o fim da vigência do convênio com a FBB?"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_operacao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_operacao", $$v)
      },
      expression: "proposta.ds_operacao"
    }
  }), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_gerais_parceria') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Parceria')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "partner"
    }
  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.partner"
    }
  }, [(_vm.ehEdital) ? _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Parceria do Projeto",
      "name": "Parceria",
      "rows": "4",
      "data-cy": "ds_parceria"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_parceria),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_parceria", $$v)
      },
      expression: "proposta.ds_parceria"
    }
  }) : _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "Parceria do Projeto",
      "name": "Parceria",
      "rows": "4",
      "data-cy": "ds_parceria",
      "placeholder": "Descreva aqui como a sua organização se relaciona com atores sociais da região. Utilize os tópicos abaixo para orientar o seu texto:\n- Como ocorrerá a participação da comunidade no projeto?\n- Como a comunidade contribuiu para identificação da demanda e elaboração da proposta?\n- Existe cooperação do governo, empresas ou outras fundações no projeto?\n- Existe envolvimento de outras organizações da sociedade civil, escolas ou universidades?\n- A sua instituição participa de alguma rede?\n- A sua instituição participa de conselho ou fórum de política pública relacionada ao tema da atual proposta?\n- A sua proposta interage com alguma política pública?"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_parceria),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_parceria", $$v)
      },
      expression: "proposta.ds_parceria"
    }
  }), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_resumo')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12  required",
    class: {
      'has-error': _vm.errors.first('sumario')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.summary"
    }
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.ehEdital ? '' : 'Nenhum texto informativo...',
      "data-vv-as": "Resumo do Projeto",
      "name": "sumario",
      "rows": "4",
      "min-height": 200,
      "autosize": true,
      "data-cy": "ds_resumo"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_resumo),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_resumo", $$v)
      },
      expression: "proposta.ds_resumo"
    }
  }), _vm._v(" "), (_vm.errors.first('sumario')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('sumario')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('informacoes_introdutorias_acoes') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12  required",
    class: {
      'has-error': _vm.errors.first('acoes')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "acoes"
    }
  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.ehEdital ? '' : 'Informe as acões de comunicação',
      "min-height": 200,
      "autosize": true,
      "data-vv-as": "indicadores",
      "name": "acoes",
      "rows": "4",
      "data-cy": "ds_acoes_comunicacao"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_acoes_comunicacao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_acoes_comunicacao", $$v)
      },
      expression: "proposta.ds_acoes_comunicacao"
    }
  }), _vm._v(" "), (_vm.errors.first('acoes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('acoes')))]) : _vm._e()], 1)])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('publico-alvo', {
    attrs: {
      "propsPublicosGrid": _vm.proposta.publicos_alvo
    },
    on: {
      "publicoAlvoAdicionado": function($event) {
        _vm.proposta.publicos_alvo = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('publico_alvo')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(6), _vm._v(" "), _c('publicoAlvoDescricao', {
    ref: "publicoAlvoDescricao",
    attrs: {
      "proposta": _vm.proposta.id,
      "fixado": false,
      "permiteEditar": true,
      "abrirAbas": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(7), _vm._v(" "), _c('tecnologiaSocial', {
    ref: "tecnologiaSocial",
    attrs: {
      "proposta": _vm.proposta.id,
      "fk_processo": _vm.proposta.fk_processo,
      "telaProjeto": false
    }
  })], 1), _vm._v(" "), (_vm.mostrarRef('equipe_do_projeto')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(8), _vm._v(" "), (_vm.entidadeEhFundacao) ? _c('span', {
    staticClass: "col-md-12 entidadeEhFundacao"
  }, [_vm._v("\n                          Dispensado registro pela proponente Fundação BB\n                        ")]) : _c('span', [_c('equipe-projeto', {
    attrs: {
      "propsEquipes": _vm.proposta.equipes
    },
    on: {
      "equipeAdicionada": function($event) {
        _vm.proposta.equipes = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('entidade_executora_proponente')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('fieldset', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityIsExecutioner"
    }
  }, [_c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.bt_entidade_executora),
      expression: "proposta.bt_entidade_executora"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-true",
      "value": "1",
      "selected": "selected"
    },
    domProps: {
      "checked": _vm._q(_vm.proposta.bt_entidade_executora, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.proposta, "bt_entidade_executora", "1")
      }
    }
  }), _vm._v(" Sim\n                                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.bt_entidade_executora),
      expression: "proposta.bt_entidade_executora"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-false",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.proposta.bt_entidade_executora, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.proposta, "bt_entidade_executora", "0")
      }
    }
  }), _vm._v(" Não\n                                  ")])])]), _vm._v(" "), (_vm.proposta.bt_entidade_executora == 0) ? _c('div', [_c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field  col-md-12",
    class: {
      'has-error': _vm.errors.first('Nome Entidade Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_entidade_nome),
      expression: "proposta.ds_entidade_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nome Entidade Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_entidade_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_entidade_nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Representante legal')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingProcurator"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_entidade_representante_legal),
      expression: "proposta.ds_entidade_representante_legal"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_representante_legal'),
      expression: "'required:!proposta.ds_entidade_representante_legal'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Representante legal",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_entidade_representante_legal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_entidade_representante_legal", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CNPJ entidade executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCNPJ"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_cnpj|cnpj'),
      expression: "'required:!proposta.ds_entidade_cnpj|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ entidade executora",
      "type": "text",
      "mask": ['##.###.###/####-##']
    },
    model: {
      value: (_vm.proposta.ds_entidade_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_entidade_cnpj", $$v)
      },
      expression: "proposta.ds_entidade_cnpj"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('E-mail executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingEmail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_entidade_email),
      expression: "proposta.ds_entidade_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_email|email'),
      expression: "'required:!proposta.ds_entidade_email|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "E-mail executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.ds_entidade_email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_entidade_email", $event.target.value)
      }, function($event) {
        _vm.proposta.ds_entidade_email = $event.target.value.toLowerCase()
      }]
    }
  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingPhone"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_telefone'),
      expression: "'required:!proposta.ds_entidade_telefone'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.ds_entidade_telefone),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_entidade_telefone", $$v)
      },
      expression: "proposta.ds_entidade_telefone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone celular da executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingMobile"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.ds_entidade_celular'),
      expression: "'required:!proposta.ds_entidade_celular'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone celular da executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.proposta.ds_entidade_celular),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_entidade_celular", $$v)
      },
      expression: "proposta.ds_entidade_celular"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CEP da executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCEP"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CEP da executora",
      "type": "text",
      "mask": ['#####-###']
    },
    model: {
      value: (_vm.proposta.entityExecutingCEP),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "entityExecutingCEP", $$v)
      },
      expression: "proposta.entityExecutingCEP"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('UF executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingState),
      expression: "proposta.entityExecutingState"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "UF executora"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.proposta, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.estados), function(uf) {
    return _c('option', {
      domProps: {
        "value": uf
      }
    }, [_vm._v(_vm._s(uf))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Cidade da Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCity"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingCity),
      expression: "proposta.entityExecutingCity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Cidade da Executora",
      "type": "text"
    },
    domProps: {
      "value": (_vm.proposta.entityExecutingCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "entityExecutingCity", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Endereço da Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingAddress"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.entityExecutingAddress),
      expression: "proposta.entityExecutingAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!proposta.entityIsExecutioner'),
      expression: "'required:!proposta.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Endereço da Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.entityExecutingAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "entityExecutingAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('projeto_de_duplicacao')) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
      expression: "usuarioLogado.userType === 'FUNDACAO'"
    }],
    staticClass: "col-md-12"
  }, [(_vm.$route.params.processo !== 'CADASTRO' && _vm.$route.params.processo !== 'SOLICITACAO' && _vm.$route.params.processo !== 'REVISAO') ? _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Projeto de duplicação")]), (_vm.$route.params.processo === 'ANALISE') ? _c('span', {
    staticStyle: {
      "color": "red",
      "margin-left": "5px",
      "font-size": "large",
      "cursor": "pointer"
    }
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.$route.params.processo !== 'CADASTRO' && _vm.$route.params.processo !== 'SOLICITACAO') ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Projeto Duplicação')
    }
  }, [_c('div', {
    attrs: {
      "name": "proposal.duplicateProject"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.nr_projeto_duplicacao),
      expression: "proposta.nr_projeto_duplicacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Projeto Duplicação",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.proposta, "nr_projeto_duplicacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.duplicador]
    }
  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.numprj
      }
    }, [_vm._v(_vm._s(projeto.numprj + ' / ' + projeto.nomprj))])
  }), 0), _vm._v(" "), (_vm.projetoSuperior !== '') ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Projeto Superior:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.projetoSuperior))])]) : _vm._e()])])])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(10), _vm._v(" "), (_vm._.has(_vm.proposta, 'fk_edital') & _vm.proposta.fk_edital !== null) ? _c('div', [_vm._v("\n                              " + _vm._s(_vm.proposta.fk_edital) + "-" + _vm._s(_vm.proposta.edital.ds_numero_edital) + "\n\n                              ")]) : _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Escolha o Edital a ser vinculado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editalSelecionado),
      expression: "editalSelecionado"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editalSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha o edital")]), _vm._v(" "), _vm._l((_vm.listaEditais), function(edital) {
    return _c('option', {
      domProps: {
        "value": edital.id
      }
    }, [_vm._v(_vm._s(edital.ds_numero_edital))])
  })], 2)]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editaEdital($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Confirmar")])], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('objetivo_especifico')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(11), _vm._v(" "), _c('objetivo-especifico', {
    attrs: {
      "editavel": true,
      "propsObjetivos": _vm.proposta.objetivos,
      "propsMetas": _vm.proposta.metas,
      "propsProposta": _vm.proposta
    },
    on: {
      "objetivoAdicionado": function($event) {
        _vm.proposta.objetivos = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('metas')) ? _c('div', {
    ref: "tabelaMetas",
    staticClass: "col-md-12"
  }, [_vm._m(12), _vm._v(" "), _c('metas', {
    attrs: {
      "editavel": true,
      "propsObjetivos": _vm.proposta.objetivos,
      "propsMetas": _vm.proposta.metas,
      "propsAtividades": _vm.proposta.atividades,
      "propsProposta": _vm.proposta,
      "atvSemMetas": _vm.atvSemMetas
    },
    on: {
      "metaAdicionada": function($event) {
        _vm.proposta.metas = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('atividades')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(13), _vm._v(" "), _c('atividades', {
    attrs: {
      "editavel": true,
      "meses": _vm.proposta.nr_periodos,
      "propsObjetivos": _vm.proposta.objetivos,
      "propsMetas": _vm.proposta.metas,
      "propsAtividades": _vm.proposta.atividades,
      "propsProposta": _vm.proposta
    },
    on: {
      "atividadeAdicionada": function($event) {
        _vm.proposta.atividades = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(14), _vm._v(" "), (!_vm.previewCotacao && !_vm.ehExcecao) ? _c('cronograma', {
    key: _vm.componentKey,
    attrs: {
      "propsObjetivos": _vm.proposta.objetivos,
      "propsAtividades": _vm.proposta.atividades,
      "metas": _vm.proposta.metas,
      "proposta": _vm.proposta,
      "meses": _vm.proposta.nr_periodos,
      "projetoDuplicacao": _vm.proposta.nr_projeto_duplicacao
    },
    on: {
      "itemAdicionado": function($event) {
        _vm.proposta.atividades = $event
      },
      "validacaoCronograma": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ehExcecao) ? _c('cronogramaCotacao', {
    key: _vm.componentKey,
    ref: "cronogramaCotacao",
    attrs: {
      "propsObjetivos": _vm.proposta.objetivos,
      "propsAtividades": _vm.proposta.atividades,
      "metas": _vm.proposta.metas,
      "proposta": _vm.proposta,
      "meses": _vm.proposta.nr_periodos,
      "projetoDuplicacao": _vm.proposta.nr_projeto_duplicacao
    },
    on: {
      "itemAdicionado": function($event) {
        _vm.proposta.atividades = $event
      },
      "validacaoCronograma": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.mostrarRef('gantt')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('visualiza-gantt', {
    attrs: {
      "numeroProjeto": null,
      "propsProposta": _vm.proposta,
      "tipoBarra": 'financeiro',
      "mostrarExecFinanc": true,
      "mostrarExecDeclarada": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.proposta.atividades, function(atv) {
    return _vm._.find(_vm._.get(atv, 'itens_orcamentos', []), function(ite) {
      return ('' + ite.adiantavel) === '1'
    })
  })) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(15), _vm._v(" "), _c('parcela-adiantamento', {
    attrs: {
      "editavel": true,
      "propsParcelas": _vm.proposta.adiantamentos,
      "propsAtividades": _vm.proposta.atividades
    },
    on: {
      "parcelaAdicionada": function($event) {
        _vm.proposta.adiantamentos = $event
      },
      "validacaoParcelasAdiantamento": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.proposta.ds_fase === 'CADASTRO') ? _c('div', {
    staticClass: "col-md-4 col-sm-6",
    class: {
      'has-error': _vm.errors.first('abrangencia')
    }
  }, [_c('div', [_c('fieldset', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("O projeto é de Abrangência Nacional?")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityIsExecutioner"
    }
  }, [_c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.bt_fep_abrangencia),
      expression: "proposta.bt_fep_abrangencia"
    }],
    attrs: {
      "type": "radio",
      "name": "abrangencia",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.proposta.bt_fep_abrangencia, "1")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.proposta, "bt_fep_abrangencia", "1")
      }, function($event) {
        return _vm.verificaAbrangenciaNacional()
      }]
    }
  }), _vm._v(" Sim\n                                ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.bt_fep_abrangencia),
      expression: "proposta.bt_fep_abrangencia"
    }],
    attrs: {
      "type": "radio",
      "name": "abrangencia",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.proposta.bt_fep_abrangencia, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.proposta, "bt_fep_abrangencia", "0")
      }
    }
  }), _vm._v(" Não\n                                ")])])])]), _vm._v(" "), (_vm.errors.first('abrangencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('abrangencia')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('municipios')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "modal-body"
  }), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('municipalizacao', {
    attrs: {
      "propsProposta": _vm.proposta,
      "editavel": true
    },
    on: {
      "municipioAdicionado": function($event) {
        _vm.proposta.municipalizacao = $event
      },
      "validacaoMunicipio": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  }), _vm._v(" "), _c('municipiosNovos', {
    attrs: {
      "municipalizacao": _vm.proposta.municipalizacao
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cursos') && (!_vm.ehEdital || !(_vm.ehEdital && _vm.editalAtivoVigente))) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(17), _vm._v(" "), _c('cursos', {
    attrs: {
      "propsCursos": _vm.proposta.cursos
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cursos')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(18), _vm._v(" "), _c('testemunhas', {
    ref: "testemunhas",
    attrs: {
      "entTestemunhas": this.entTestemunhas,
      "idProposta": this.$route.params.id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('cursos')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(19), _vm._v(" "), _c('agenciaIndicativaContaProjeto', {
    ref: "agenciaIndicativa",
    attrs: {
      "proposta": this.proposta,
      "agenciaSelecionadaProp": this.proposta.hasOwnProperty('agenciaSelecionada') ? this.proposta.agenciaSelecionada : null
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('documentos')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(20), _vm._v(" "), _c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.documentosProposta,
      "documentTypes": _vm.proposta.tipo_documentos,
      "localUso": 'PROPOSTA_COMPLETA_DOCUMENTOS_ANEXOS',
      "propsEtapa": _vm.nulo
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "row-flex all-start gap-10"
  }, [_c('label', [_vm._v("Mostra anexos cotação:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.abrirVisualizacaoCotacao),
      expression: "abrirVisualizacaoCotacao"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.abrirVisualizacaoCotacao) ? _vm._i(_vm.abrirVisualizacaoCotacao, null) > -1 : (_vm.abrirVisualizacaoCotacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.abrirVisualizacaoCotacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.abrirVisualizacaoCotacao = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.abrirVisualizacaoCotacao = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.abrirVisualizacaoCotacao = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [(_vm.abrirVisualizacaoCotacao) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos da Cotacao")]) : _vm._e()]), _vm._v(" "), (_vm.abrirVisualizacaoCotacao) ? _c('visualizacaoDocumentosCotacao', {
    attrs: {
      "proposta": _vm.proposta
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.mostrarRef('historico')) ? _c('fieldset', {
    attrs: {
      "enabled": this.$router.currentRoute.name === 'proposta-visualiza'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.esconder === true),
      expression: "usuarioLogado.userType === 'FUNDACAO' && esconder === true"
    }],
    staticClass: "col-md-12"
  }, [_vm._m(21), _vm._v(" "), _c('historico-proposta', {
    attrs: {
      "proposta": _vm.proposta
    },
    on: {
      "historico_itens": function($event) {
        _vm.historico_atualizado = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('fieldset', [(_vm.esconder === true) ? _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.irTopo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  }, [_vm._v(" Ir para o início")])])]) : _vm._e(), _vm._v(" "), ((this.$route.params.processo !== 'SOLICITACAO' && !_vm._.isNull(_vm.proposta) && !_vm._.isEmpty(_vm.proposta))) ? _c('fieldset', [((this.$route.params.processo === 'ANALISE') || (_vm.proposta.ds_fase === 'ANALISE' && !_vm._.isEmpty(this.analise))) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
      expression: "usuarioLogado.userType === 'FUNDACAO'"
    }]
  }, [_c('analise', {
    ref: "analise",
    attrs: {
      "propsAnalise": _vm.proposta,
      "propsFluxo": _vm.fluxo
    },
    on: {
      "analiseProposta": function($event) {
        _vm.analise = $event
      },
      "setPropostaSimplificada": function($event) {
        return _vm.setPropostaSimplificada($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && ((this.$router.currentRoute.name === 'proposta-visualiza' && _vm.proposta.ds_fase === 'ANALISE'))) ? _c('div', [_c('analise', {
    ref: "analise",
    attrs: {
      "propsAnalise": _vm.proposta,
      "propsFluxo": _vm.fluxo
    },
    on: {
      "analiseProposta": function($event) {
        _vm.analise = $event
      },
      "setPropostaSimplificada": function($event) {
        return _vm.setPropostaSimplificada($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.proposta.ds_fase === 'DEFERIMENTO' || _vm.proposta.ds_fase === 'FORMALIZACAO' || _vm.proposta.ds_fase === 'APROVACAO_PROJETO') ? _c('div', {
    staticClass: "text-left box-header"
  }, [(_vm.esconderAnalise === false) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderAnalise = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar a análise realizada em "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.analiseData, 'L')))]), _vm._v(" "), (_vm.analiseUsuario !== null) ? _c('span', [_vm._v(" por "), _c('b', [_vm._v(_vm._s(_vm.analiseUsuario))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderAnalise === true) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderAnalise = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocultar a análise")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderAnalise === true) ? _c('div', [_c('analise', {
    ref: "analise",
    attrs: {
      "propsAnalise": _vm.proposta,
      "propsFluxo": _vm.fluxo
    },
    on: {
      "setPropostaSimplificada": function($event) {
        return _vm.setPropostaSimplificada($event)
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && ((this.$route.params.processo === 'DEFERIMENTO' && this.$router.currentRoute.name !== 'proposta-visualiza') || (_vm.proposta.ds_fase === 'DEFERIMENTO' && !_vm._.isEmpty(this.deferimento)))) ? _c('div', [_c('deferimento', {
    ref: "child",
    attrs: {
      "propsDeferimento": _vm.proposta,
      "propsFluxo": _vm.fluxo
    },
    on: {
      "deferimentoProposta": function($event) {
        _vm.deferimento = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && this.$router.currentRoute.name === 'proposta-visualiza' && _vm.proposta.ds_fase === 'DEFERIMENTO') ? _c('div', [_c('deferimento', {
    ref: "child",
    attrs: {
      "propsDeferimento": _vm.proposta,
      "propsFluxo": _vm.fluxo
    },
    on: {
      "deferimentoProposta": function($event) {
        _vm.deferimento = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (this.$route.params.processo === 'FORMALIZACAO' && this.$router.currentRoute.name !== 'proposta-visualiza') || (_vm.proposta.ds_fase === 'FORMALIZACAO' && !_vm._.isEmpty(this.formalizacao) && this.$router.currentRoute.name !== 'proposta-visualiza')) ? _c('div', [_c('formalizacao', {
    ref: "child",
    attrs: {
      "propsFormalizacao": _vm.proposta,
      "propsAdiantaveis": _vm.possuiItensAdiantaveis
    },
    on: {
      "formalizacaoProposta": function($event) {
        _vm.proposta = $event
      },
      "validacaoFormalizacao": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && this.$router.currentRoute.name === 'proposta-visualiza' && _vm.proposta.ds_fase === 'FORMALIZACAO') ? _c('div', {
    attrs: {
      "propsAdiantaveis": _vm.possuiItensAdiantaveis
    }
  }, [_c('formalizacao', {
    ref: "child",
    attrs: {
      "propsFormalizacao": _vm.proposta
    },
    on: {
      "formalizacaoProposta": function($event) {
        _vm.proposta = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (this.$route.params.processo === 'APROVACAO_PROJETO' && this.$router.currentRoute.name !== 'proposta-visualiza') || (_vm.proposta.ds_fase === 'APROVACAO_PROJETO' && !_vm._.isEmpty(this.aprovacao) && this.$router.currentRoute.name !== 'proposta-visualiza')) ? _c('div', [_c('aprovacao', {
    ref: "child",
    attrs: {
      "propsAprovacao": _vm.proposta
    },
    on: {
      "aprovacaoProposta": function($event) {
        _vm.aprovacao = $event
      },
      "validacaoAprovacao": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && this.$router.currentRoute.name === 'proposta-visualiza' && _vm.proposta.ds_fase === 'APROVACAO_PROJETO') ? _c('div', [_c('aprovacao', {
    ref: "child",
    attrs: {
      "propsAprovacao": _vm.proposta
    },
    on: {
      "aprovacaoProposta": function($event) {
        _vm.aprovacao = $event
      }
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "z-index": "10000"
    }
  })])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa fa-info"
  }), _vm._v("   Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("A Entidade possui restrições impeditivas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alerta!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações do Projeto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Público-alvo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Detalhamento do Público-alvo "), _c('strong', [_vm._v("Previsto")]), _vm._v(":")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Tecnologia Social:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Equipe do Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Entidade executora")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Edital")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Objetivo Específico")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Metas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Atividades")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cronograma Físico-Financeiro")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Parcela de Adiantamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Municípios - Locais de execução")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cursos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Testemunhas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Indicação de Agência")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos da Proposta")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico de Aprovações:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4e503c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposta/EditaProposta.vue
// module id = 1996
// module chunks = 2